// extracted by mini-css-extract-plugin
module.exports = {"meetTheTeamSection":"ourTeam-module--meetTheTeamSection--2NlLE","officers":"ourTeam-module--officers--3gMR8","tMItem":"ourTeam-module--tMItem--2IuRv"};